(function () {
  var API = 'https://jewelyecom.in/alankar/api/gold_rates_public';
  var ALLOWED = ['gold_22kt', 'gold_18kt', 'gold_14kt', 'gold_9kt'];
  var KARAT_LABEL = { gold_22kt: '22KT Gold', gold_18kt: '18KT Gold', gold_14kt: '14KT Gold', gold_9kt: '9KT Gold' };
  var WATERMARK = { gold_22kt: '22', gold_18kt: '18', gold_14kt: '14', gold_9kt: '9' };

  function fmt(n) {
    if (!n) return '—';
    return new Intl.NumberFormat('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n);
  }

  function fmtTime(str) {
    if (!str) return '';
    try {
      var d = new Date(str.replace(' ', 'T') + '+05:30');
      return 'Updated ' + d.toLocaleString('en-IN', {
        day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit',
        hour12: true, timeZone: 'Asia/Kolkata'
      });
    } catch (e) { return 'Updated recently'; }
  }

  function buildTicker(rates) {
    var el = document.getElementById('agdRatesTicker');
    if (!el) return;
    var html = '';
    for (var pass = 0; pass < 2; pass++) {
      rates.forEach(function (r) {
        html += '<span class="agd-ticker-item">'
          + '<span class="agd-ti-label">' + KARAT_LABEL[r.key] + '</span>'
          + '<span class="agd-ti-value">₹' + fmt(r.value) + '</span>'
          + '<span class="agd-ti-unit">/ g</span>'
          + '</span>'
          + '<span class="agd-ti-sep">◆</span>';
      });
    }
    el.innerHTML = html;
  }

  function buildCards(rates) {
    var grid = document.getElementById('agdRatesCards');
    if (!grid) return;
    var html = '';
    rates.forEach(function (r) {
      html += '<div class="agd-rate-card agd-card-featured">'
        + '<div class="agd-card-watermark">' + WATERMARK[r.key] + '</div>'
        + '<div class="agd-card-icon-bar"><div class="agd-card-dot"></div><div class="agd-card-line"></div></div>'
        + '<div class="agd-card-karat">' + KARAT_LABEL[r.key] + '</div>'
        + '<div class="agd-card-price"><sup>₹</sup>' + fmt(r.value) + '</div>'
        + '<div class="agd-card-unit">Per Gram</div>'
        + '</div>';
    });
    grid.innerHTML = html;
  }

  function load() {
    fetch(API)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data.success) return;

        var filtered = data.rates.filter(function (r) {
          return ALLOWED.indexOf(r.key) !== -1;
        });
        filtered.sort(function (a, b) {
          return ALLOWED.indexOf(a.key) - ALLOWED.indexOf(b.key);
        });

        /* Share with other scripts (e.g. the Old Gold Exchange section).
           Published first so they update even if the ticker markup is not on the page. */
        window.AGD_RATES = { rates: filtered, updated_at: data.updated_at };
        document.dispatchEvent(new CustomEvent('agd:rates', { detail: window.AGD_RATES }));

        buildTicker(filtered);
        buildCards(filtered);

        var meta = document.getElementById('agdRatesMeta');
        if (meta) meta.textContent = fmtTime(data.updated_at);
      })
      .catch(function () {
        var g = document.getElementById('agdRatesCards');
        if (g) g.innerHTML = '<div style="grid-column:1/-1;text-align:center;color:#aaa;font-size:12px;padding:40px 0">Rates temporarily unavailable</div>';
      });
  }

  /* Works whether this file loads before or after DOMContentLoaded (defer/async safe) */
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', load);
  else load();
  setInterval(load, 5 * 60 * 1000);
})();